import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=d274dd3c&scoped=true&"
import script from "./Feed.vue?vue&type=script&lang=js&"
export * from "./Feed.vue?vue&type=script&lang=js&"
import style0 from "./Feed.vue?vue&type=style&index=0&id=d274dd3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d274dd3c",
  null
  
)

export default component.exports